<template>
  <section class="fun">
    <h2 class="fun__balloon">
      <img
        :src="require(`@/assets/images/fun-balloon.svg`)"
        width="231"
        height="81.5"
        :alt="`プールの楽しみ方`"
      >
    </h2>
    <div class="fun__content">
      <picture>
        <source
          media="(min-width: 768px)"
          :srcset="require(`@/assets/images/${resultCode}-fun-content-pc.png`)"
        >
        <img
          :src="require(`@/assets/images/${resultCode}-fun-content-sp.png`)"
          :alt="imageAlt"
        >
      </picture>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ResultFun',
  props: {
    resultCode: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/foundation/config/colors";
@use "@/assets/scss/foundation/config/mediaquery";
@use "@/assets/scss/foundation/mixin";

.fun__balloon img {
  @include mediaquery.minMediaMajor {
    width: 320px;
  }
}

.fun__content {
  margin-top: 24px;
  text-align: center;
  @include mediaquery.minMediaMajor {
    margin-top: 65px;
  }

  picture,
  img {
    display: inline-block;
    width: 100%;
    max-width: 400px;
    height: auto;
    @include mediaquery.minMediaMajor {
      max-width: 856px;
    }
  }
}
</style>